export const REQUEST_SUBSCRIBE_EXPIRE_TIME = 1000 * 60 * 5; // 5 minutes

// How many notifications cards are displayed in a stack when not expanded.
export const GROUP_MINIMIZED_STACK_SIZE = 3;
export const SETTINGS_APPLICATIONS_COLLAPSED_SIZE = 11;

export const TOAST_WINDOW_NAME = 'Notification-Toast';

export const NOTIFICATION_CENTER_WIDTH = 344;
export const NOTIFICATION_CENTER_ANIMATION_DURATION = 300;

export const MIN_SEARCH_STRING_LENGTH = 1;
